import React from 'react';
import { FiUsers, FiX } from 'react-icons/fi';

const ActionBar = ({ playerSearch, onClearSearch, comparePlayers, onRemoveFromComparison, onViewComparison }) => {
  if (!playerSearch && comparePlayers.length === 0) return null;

  return (
    <div className="action-bar">
      {playerSearch && (
        <div className="search-active">
          <span>Searching: "{playerSearch}"</span>
          <button className="clear-btn" onClick={onClearSearch}>
            <FiX /> Clear
          </button>
        </div>
      )}
      {comparePlayers.length > 0 && (
        <div className="comparison-active">
          <FiUsers /> Comparing {comparePlayers.length} player(s):
          {comparePlayers.map(player => (
            <span key={player} className="compare-tag">
              {player}
              <button onClick={() => onRemoveFromComparison(player)}>
                <FiX size={12} />
              </button>
            </span>
          ))}
          <button className="view-comparison-btn" onClick={onViewComparison}>
            View Comparison
          </button>
        </div>
      )}
    </div>
  );
};

export default ActionBar;

